<div *ngIf="disclaimer | async as disclaimer" class="surveys-element-disclaimer">
    <surveys-element-html *ngIf="hasDisclaimer(disclaimer)" [element]="{data: disclaimer}"> </surveys-element-html>
</div>
